import React, { useState, useEffect, useRef, useCallback, useMemo } from "react"
import {
  useHistory,
  useNotification,
} from "@orbital/games-frontend-library"

import { defaultPlaceBet, defaultSettings } from "./lib/defaultValues"
import Astro from "./astro/Astro"
import { socketMessages } from "./lib/astroSocketMessages"
import { useSwitchErrorCode } from "./helpers/errorCodeHandler"
import { cashoutResponceHelper } from "./helpers/cashoutResponce"
import { Provider } from "./context/createContext"
import { defaultContext } from "./context/defaultContext"
import {
  handleStakeHelper,
  handleClearHelper,
  handleAudioHelper,
  handleAutoCurrentHelper,
  handleAutoHelper,
  handleAutoConfigstHelper,
  handleFuncsInContext,
} from "./context/helpers"

import { roundUserUpdateHelper } from "./helpers/roundUserUpdateHelper"
import { autoNextStep } from "./helpers/autoNextStep"
import { createSocket } from "./socket/createSocket"
import { useReceiveMessages } from "./socket/receiveMessages"
import { createMessage } from "./socket/createMessage"

let timeout: any

const App = () => {
  const WS_URL = "{{SERVER_WS_URL}}"
  const name = "astro"
  const socket = useRef<any>(null)
  const [ctx, setctx] = useState(defaultContext)
  const { auth, autoConfigs, autoCurrent, stake, config } = ctx
  const { minbet, prec } = config

  const [round, setround] = useState({ state: 0 })
  const roundUpdate = (e: any) => setround(e)

  const [errorCode, setErrorCode] = useState<number>(0)
  const [isError, setIsError] = useState<boolean>(false)
  const [errorText, setErrorText] = useState<string | false>(false)
  const handleErrorText = useCallback(
    (text: string) =>
      setErrorText((errorText) => (errorText ? errorText : text)),
    []
  )

  const [settings, setSettings] = useState(defaultSettings)

  const updateSettings = useCallback((settings) => {
    setSettings(settings)
  }, [])

  useEffect(() => {
    if (settings.stake === "0.00" && minbet !== "0") {
      setSettings({
        ...settings,
        stake: Number(minbet).toFixed(prec).toString(),
      })
    }
  }, [minbet, prec, settings])

  const [betSend, setbetSend] = useState(false)

  const [placedBet, setPlacedBet] = useState(defaultPlaceBet)

  const [betError, setBetError] = useState(0)

  useEffect(() => {
    console.log(
      "%cV.2.0.3 DG",
      "color: pink; background: black; padding: 5px; border-radius: 8px;"
    )
  }, [])

  const placeBetResponce = (e: any) => {
    setbetSend(false)
    updateBalanceResponce(e)
    setPlacedBet({
      balance: e.balance,
      bet: e.bet,
      currency: e.currency,
      state: e.state,
      error: e.error,
      index: e.index,
    })
    setBetError(e.error.code)
  }

  const [notification, handleNotification, notificationfadeOut] =
    useNotification()

  const [betOnExplosion, setBetOnExplosion] = useState<boolean>(false)
  const handleBetOnExplosion = (b: boolean) => setBetOnExplosion(b)

  const [
    history,
    // addInHistory
  ] = useHistory(auth.player_id)

  const [users, setusers] = useState<any[]>([])
  const [cashoutedUser, setCashoutedUser] = useState("")

  const roundUserUpdate = (e: any) => {
    roundUserUpdateHelper(setusers, e, setCashoutedUser)
  }
  const cashoutResponce = (e: any) =>
    cashoutResponceHelper(e, handleNotification)

  const receiveMessage = useReceiveMessages({
    setctx,
    roundUpdate,
    placeBetResponce,
    roundUserUpdate,
    cashoutResponce,
    handleErrorText,
    handleNotification,
    setErrorCode,
    updateSettings,
  })

  const handleStake = useCallback(
    (stake: string) => handleStakeHelper(stake, setctx),
    [setctx]
  )

  const handleClear = useCallback(
    () => handleClearHelper(setctx, Number(minbet).toFixed(prec)),
    [setctx, minbet, prec]
  )

  // const { globalSocketMessages, astroSocketMessages } = SendMessages(socket)
  const setBalance = (balance: string) => {
    setctx((ctx) => {
      ctx.auth.balance.amount = balance
      return { ...ctx }
    })
  }
  const updateBalanceResponce = (e: any) => setBalance(e.balance)

  const sendSocketMessage = useCallback((...args: any) => {
    const message = createMessage(...args)
    socket.current.sendMessage(message)
  }, [])

  const astroSocketMessages = useMemo(
    () => socketMessages(sendSocketMessage),
    [sendSocketMessage]
  )

  const setAudio = useCallback(
    (audio: any) => {
      handleAudioHelper(audio, setctx)
    },
    [setctx]
  )

  const stopAuto = useCallback(
    () =>
      handleAutoCurrentHelper(
        {
          betsRemained: "",
          isAutoOn: false,
        },
        setctx
      ),
    [setctx]
  )
  const setAutoCurrent = useCallback(
    (autoCurrent: any) => handleAutoCurrentHelper(autoCurrent, setctx),
    [setctx]
  )
  const setAutoConfigs = useCallback(
    (auto: any) => handleAutoConfigstHelper(auto, setctx),
    [setctx]
  )
  const handleAuto = useCallback(
    (auto) => handleAutoHelper(auto, setAutoConfigs, setAutoCurrent),
    [setAutoConfigs, setAutoCurrent]
  )

  useSwitchErrorCode(errorCode, setIsError, setErrorCode)

  useEffect(() => {
    setusers([
      {
        id: auth.player_id,
        name: auth.player_name,
        bet: null,
        cashout: null,
      },
    ])
  }, [auth.player_id, auth.player_name, setusers])

  useEffect(() => {
    if (!socket.current)
      socket.current = createSocket(
        WS_URL,
        receiveMessage,
        name,
        handleErrorText
      )
  }, [socket, receiveMessage, handleErrorText])

  useEffect(() => {
    handleStake(settings.stake)
  }, [settings, handleStake])

  useEffect(() => {
    if (betSend) {
      astroSocketMessages.settingsPost({
        ...settings,
        stake,
        numOfBets: autoConfigs.numOfBets,
        cashoutAt: autoConfigs.cashoutAt,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    betSend,
    astroSocketMessages,
    autoConfigs.numOfBets,
    autoConfigs.cashoutAt,
    stake,
  ])

  useEffect(() => {
    const auto = {
      betAmount: settings.stake,
      numOfBets: settings.numOfBets,
      cashoutAt: settings.cashoutAt,
    }
    setAutoConfigs(auto)
  }, [settings, setAutoConfigs])

  useEffect(() => {
    handleFuncsInContext(
      setctx,
      stopAuto,
      handleStake,
      handleClear,
      setAudio,
      handleAuto,
      handleErrorText
    )
  }, [
    stopAuto,
    handleStake,
    handleClear,
    setAudio,
    handleAuto,
    handleErrorText,
  ])

  useEffect(() => {
    // if (autoCurrent.isAutoOn) {
    autoNextStep(
      round,
      autoCurrent,
      stake,
      auth.balance.amount,
      autoConfigs,
      astroSocketMessages,
      handleNotification,
      stopAuto,
      setusers,
      betOnExplosion,
      handleBetOnExplosion,
      notification,
      setbetSend,
      betError
    )
    // }
  }, [
    round,
    autoCurrent,
    autoConfigs,
    stake,
    auth.balance.amount,
    astroSocketMessages,
    handleNotification,
    stopAuto,
    setusers,
    betOnExplosion,
    notification,
    betError,
  ])

  useEffect(() => {
    if (!ctx.astroSocketMessages) {
      setctx((ctx: any) => {
        return { ...ctx, astroSocketMessages }
      })
    }
  }, [ctx.astroSocketMessages, astroSocketMessages])

  useEffect(() => {
    if (round.state === 2 && notification !== "Stage Timeout") {
      setBetError(0)
    }
    if (round.state === 3) {
      setBetError(0)
    }

    return () => clearTimeout(timeout)
  }, [round, notification])

  return (
    <Provider value={{ ctx, setctx }}>
      <Astro
        round={round}
        users={users}
        history={history}
        cashoutedUser={cashoutedUser}
        isError={isError}
        errorText={errorText}
        notification={notification}
        handleNotification={handleNotification}
        notificationfadeOut={notificationfadeOut}
        placedBet={placedBet}
        handleBetOnExplosion={handleBetOnExplosion}
        settings={settings}
        astroSocketMessages={astroSocketMessages}
        setbetSend={setbetSend}
        betError={betError}
      />
    </Provider>
  )
}

export default App
